import {
  COMPOUND_NOTES_LOAD_REQUEST,
  COMPOUND_NOTES_LOAD_SUCCESS,
  COMPOUND_NOTES_LOAD_FAILURE,
  COMPOUND_NOTE_EDIT_START,
  COMPOUND_NOTE_EDIT_CANCEL,
  COMPOUND_NOTE_CREATE_SUCCESS,
} from '../actions/compoundNote';

const initialState = {
  notes: [],
  loaded: false,
  editing: false,
};

function initializeState(){
  return Object.assign({}, initialState);
}

export default function compoundNotes(state = initializeState(), action = {}) {
  switch (action.type) {
    case COMPOUND_NOTES_LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case COMPOUND_NOTES_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        notes: action.notes,
        error: null
      };
    case COMPOUND_NOTES_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        notes: null,
        error: action.error
      };

    case COMPOUND_NOTE_EDIT_START:
      return {
        ...state,
        editing: true
      };
    case COMPOUND_NOTE_EDIT_CANCEL:
      return {
        ...state,
        editing: false
      };

    case COMPOUND_NOTE_CREATE_SUCCESS:
      let notes = [...state.notes];
      return {
        ...state,
        notes: [action.note, ...notes],
        editing: false,
      };

    default:
      return state;
  }
}
